import AuthorizationFileInput from './AuthorizationFileInput';

export default AuthorizationFileInput;
